/**
 * Utility functions to detect CMS editing mode
 */

/**
 * Check if the current page is in CMS editing mode
 * @returns {boolean} True if in CMS editing mode, false otherwise
 */
export function isCmsEditingMode() {
  try {
    // Check if body has cmsedit class
    const body = document.querySelector('body');
    if (body && body.classList.contains('cmsedit')) {
      return true;
    }
    
    // Check if we're in a CMS edit page (URL contains cms edit parameters)
    const urlParams = new URLSearchParams(window.location.search);
    const cmsViewMode = urlParams.get('cmsViewMode');
    if (cmsViewMode && cmsViewMode !== 'viewonly') {
      return true;
    }
    
    // Check if we're on a CMS edit page path
    const pathname = window.location.pathname;
    if (pathname.includes('/cms/') || pathname.includes('/edit')) {
      return true;
    }
    
    return false;
  } catch (error) {
    console.warn('Error detecting CMS editing mode:', error);
    return false;
  }
}

/**
 * Check if popup forms should be hidden based on CMS editing mode
 * @returns {boolean} True if popup forms should be hidden, false otherwise
 */
export function shouldHidePopupForms() {
  return isCmsEditingMode();
} 